import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";
import "font-awesome/css/font-awesome.min.css";
import logo from '../assets/images/logo.png';

const Home = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState(null);

  useEffect(() => {
    // Scroll handler for header
    const handleScroll = () => {
      setScrolled(window.scrollY >= 60);
      
      // Show/hide back to top button
      const topButton = document.querySelector('.top');
      if (topButton) {
        if (window.scrollY >= 550) {
          topButton.style.display = 'flow';
        } else {
          topButton.style.display = 'none';
        }
      }
    };
    
    window.addEventListener("scroll", handleScroll);
    
    // Page loader hide
    const timer = setTimeout(() => {
      const loader = document.querySelector(".pageloader");
      if (loader) loader.style.display = "none";
    }, 500);

    // Simple particles effect without external library
    const createParticles = () => {
      const canvas = document.createElement('canvas');
      const container = document.getElementById('particles-js');
      if (!container) return;
      
      container.style.position = 'relative';
      container.style.overflow = 'hidden';
      container.style.height = '100%';
      
      canvas.style.position = 'absolute';
      canvas.style.top = '0';
      canvas.style.left = '0';
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.style.zIndex = '1';
      container.appendChild(canvas);
      
      const ctx = canvas.getContext('2d');
      let particles = [];
      let animationId;
      
      const resizeCanvas = () => {
        canvas.width = container.clientWidth;
        canvas.height = container.clientHeight;
      };
      
      const createParticle = () => {
        return {
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          radius: Math.random() * 3 + 1,
          speedX: (Math.random() - 0.5) * 0.5,
          speedY: (Math.random() - 0.5) * 0.5,
          opacity: Math.random() * 0.5 + 0.2
        };
      };
      
      const init = () => {
        resizeCanvas();
        for (let i = 0; i < 80; i++) {
          particles.push(createParticle());
        }
        animate();
      };
      
      const animate = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        particles.forEach(particle => {
          particle.x += particle.speedX;
          particle.y += particle.speedY;
          
          if (particle.x < 0) particle.x = canvas.width;
          if (particle.x > canvas.width) particle.x = 0;
          if (particle.y < 0) particle.y = canvas.height;
          if (particle.y > canvas.height) particle.y = 0;
          
          ctx.beginPath();
          ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255, 255, 255, ${particle.opacity})`;
          ctx.fill();
        });
        
        animationId = requestAnimationFrame(animate);
      };
      
      window.addEventListener('resize', () => {
        resizeCanvas();
        particles = [];
        for (let i = 0; i < 80; i++) {
          particles.push(createParticle());
        }
      });
      
      init();
      
      return () => {
        if (animationId) cancelAnimationFrame(animationId);
        window.removeEventListener('resize', resizeCanvas);
      };
    };
    
    // Start particles effect
    const cleanupParticles = createParticles();
    
    // TradingView Widget
    const tradingScript = document.createElement("script");
    tradingScript.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    tradingScript.async = true;
    tradingScript.innerHTML = JSON.stringify({
      "symbols": [
        { "proName": "FX_IDC:XAUUSD", "title": "Gold" },
        { "proName": "FX_IDC:XAGUSD", "title": "Silver" },
        { "proName": "FX_IDC:XPTUSD", "title": "Platinum" },
        { "proName": "FX_IDC:XPDUSD", "title": "Palladium" }
      ],
      "showSymbolLogo": true,
      "colorTheme": "dark",
      "isTransparent": false,
      "displayMode": "regular",
      "locale": "en"
    });
    
    const tradingContainer = document.querySelector('.tradingview-widget-container');
    if (tradingContainer) {
      tradingContainer.appendChild(tradingScript);
    }
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timer);
      if (cleanupParticles) cleanupParticles();
    };
  }, []);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="grownit-clone">
      <div className="pageloader"></div>

      {/* Header Section */}
      <header className={scrolled ? "fheader" : ""}>
        <div className="wrapper">
          <div className="mobbar" onClick={() => setMobileMenuOpen(true)}>
            <i className="fa fa-bars"></i>
          </div>
          <div className="logo">
            <img src={logo} alt="LogicraNetwork" />
          </div>
          <div className="mobac">
            <Link className="fa fa-user" to="/login"></Link>
          </div>
          <nav style={{ display: mobileMenuOpen ? "block" : "" }}>
            <ul>
              <li>
                <img className="slogo" src={logo} alt="logo" />
                <div className="close" onClick={() => setMobileMenuOpen(false)}>
                  <i className="fa fa-close"></i>
                </div>
                <div className="split"></div>
              </li>
              <li><a href="#top" onClick={() => setMobileMenuOpen(false)}>Home</a></li>
              <li><a href="#features" onClick={() => setMobileMenuOpen(false)}>Features</a></li>
              <li><a href="#tradingai" onClick={() => setMobileMenuOpen(false)}>AI Trading</a></li>
              <li><a href="#forex" onClick={() => setMobileMenuOpen(false)}>What is Forex?</a></li>
              <li><a href="#market" onClick={() => setMobileMenuOpen(false)}>Market Trend</a></li>
              <li><a href="#affiliate" onClick={() => setMobileMenuOpen(false)}>Affiliate</a></li>
              <li><a href="#whyus" onClick={() => setMobileMenuOpen(false)}>Why Us?</a></li>
              <li><a href="#faq" onClick={() => setMobileMenuOpen(false)}>FAQs?</a></li>
              <li>
                <div className="account">
              <Link className="fa fa-user" to="/login">My Account</Link>
                </div>
              </li>
            </ul>
          </nav>
          <div className="account accounthide">
             <Link className="fa fa-user" to="/login">My Account</Link>
          </div>
        </div>
      </header>

      {/* Main Screen Section */}
      <section id="mainscreen">
        <div id="particles-js"></div>
        <div className="wrapper">
          <div className="leftmaincontent">
            <br />
            <h1>Forex. Bots. Results.</h1>
            <br />
            <h2>We're building intelligent trading bots to grow your capital 24/7.</h2>
            <br />
            <Link to="/login" className="mlink">LOGIN</Link>
          </div>
          <div className="rightmaingraphic"></div>
        </div>
      </section>

      {/* TradingView Widget Container */}
      {/* <div className="tradingview-widget-container">
        <div className="tradingview-widget-container__widget"></div>
      </div> */}

      {/* Features Section */}
      <section id="features">
        <div className="wrapper">
          <h2>Features</h2>
          <ul>
            <li>
              <img src="https://grownit.io/imgs/technical-analysis-icon.png" alt="Technical Analysis" />
              <h3>Technical<br />Analysis</h3>
              <p>It uses advanced algorithms to identify trends and patterns, enabling precise entry and exit points for manual trading.</p>
            </li>
            <li>
              <img src="https://grownit.io/imgs/fundmedals-analysis.png" alt="Fundamental Analysis" />
              <h3>Fundamental<br />Analysis</h3>
              <p>It continuously monitors economic indicators and news, adapting strategies based on real-time market conditions.</p>
            </li>
            <li>
              <img src="https://grownit.io/imgs/money-management-control-icon.png" alt="Money Management" />
              <h3>Money<br />Management Tool</h3>
              <p>It helps control trades in more detail by setting multiple take-profit levels, trailing stop-losses, placing price alarms, and more.</p>
            </li>
            <li>
              <img src="https://grownit.io/imgs/telegram-icon.png" alt="Telegram Signal Copier" />
              <h3>Telegram<br />Signal Copier</h3>
              <p>It copies forex signals, either manually or automatically, from MT4 or MT5 accounts to any Telegram channel with real-time accuracy.</p>
            </li>
            <li>
              <img src="https://grownit.io/imgs/automated-trade-icon.png" alt="Fully Automated" />
              <h3>Fully<br />Automated!</h3>
              <p>It scans trends and analyzes each trade, making its own decisions to choose the best option for the current market.</p>
            </li>
          </ul>
          <div className="split"></div>
        </div>
      </section>

      {/* Experience Section */}
      <section id="exper">
        <div className="wrapper">
          <div className="experban">
            <div className="banhead">
              <h2>Experience AI-Powered Trading Today.</h2>
              <h4>Let <u>LogicraNetwork</u> handle your trades with precision and consistency.</h4>
            </div>
            <div className="cta">
              <a href="register.php">Start Now <i className="fa fa-angle-right"></i></a>
            </div>
          </div>
        </div>
      </section>

      {/* AI Trading Section */}
      <section id="tradingai">
        <div className="wrapper">
          <h2>AI Trading</h2>
          <div className="ai-content">
            <p>AI trading integrates Artificial Intelligence capabilities into algorithmic trading systems.</p>
            <p>AI trading bots have the capacity to crunch a vast amount of technical and fundamental market data in real time, relating to a wide variety of financial markets such as stocks, commodities, bonds, indices, forex, and crypto.</p>
            <p>AI trading systems can perform a wide range of activities, including historical price and volume analysis, risk assessment, signal creation, entry and exit suggestions, strategy testing, and trade execution.</p>
            <p>One rapidly developing area of AI is Machine Learning. It enables trading bots to identify, analyze, and draw inferences from data patterns so they can adapt to shifting market conditions and respond to trading opportunities without explicitly programmed instructions.</p>
          </div>
          
          <div className="advantages-section">
            <h3>Advantages of AI Trading</h3>
            <p className="advantages-subtitle">Benefit from the speed, efficiency, and unparalleled accuracy of AI-based trading technology</p>
            
            <div className="advantages-grid">
              <div className="advantage-card">
                <div className="advantage-number">01</div>
                <h4>Exceptional Processing Speed</h4>
                <p>Trading bots can process huge volumes of daily market data from a wide variety of trading-related sources almost instantly at a speed no human could match.</p>
              </div>
              <div className="advantage-card">
                <div className="advantage-number">02</div>
                <h4>Ability to Learn and Improve</h4>
                <p>Machine learning capabilities will enable bots to learn from all the data it receives to gain an increasingly in-depth understanding of market trends and patterns.</p>
              </div>
              <div className="advantage-card">
                <div className="advantage-number">03</div>
                <h4>Complex Analytical Capabilities</h4>
                <p>An AI-based trading system can instantly perform complex and time-consuming technical analysis, identifying price trends across multiple markets simultaneously.</p>
              </div>
              <div className="advantage-card">
                <div className="advantage-number">04</div>
                <h4>Emotion-free Decision Making</h4>
                <p>Completely data-driven, a trading bot will always make the optimal move based on pure statistics, avoiding emotional decisions driven by greed or fear.</p>
              </div>
              <div className="advantage-card">
                <div className="advantage-number">05</div>
                <h4>Expanding Market Accessibility</h4>
                <p>AI bots give you access to top-notch market expertise even if you don't have a financial background, a large amount of capital to invest, or hours of free time.</p>
              </div>
            </div>
          </div>
          
          <div className="newtab">
            <a href="#">Start Today</a>
          </div>
        </div>
      </section>

      {/* Steps Section */}
      <section id="steps">
        <div className="wrapper">
          <h2>Get started in 3 easy steps</h2>
          <ul>
            <li className="stepwbg">
              <h3>Choose<br />Your Plan</h3>
              <img className="stepgraphic" src="https://grownit.io/imgs/chooseplan.gif" alt="Choose Plan" />
              <p>Choose a plan that suits your trading needs whether you're a beginner or advanced to optimize your trades with AI-powered decision-making strategies.</p>
            </li>
            <li className="separrow">
              <img src="https://grownit.io/imgs/arrown.png" alt="arrow" />
            </li>
            <li className="stepwbg mtmin">
              <h3>Connect Your<br />Trading Account</h3>
              <img className="stepgraphic" src="https://grownit.io/imgs/connecttrading.gif" alt="Connect Trading" />
              <p>Install and connect LogicraNetwork to your trading platform, such as MT4 or MT5, using the easy step-by-step instructions in the help center. Then start automated trading.</p>
            </li>
            <li className="separrow">
              <img src="https://grownit.io/imgs/arrown.png" alt="arrow" />
            </li>
            <li className="stepwbg">
              <h3>Start Automated<br />Trading</h3>
              <img className="stepgraphic" src="https://grownit.io/imgs/automated-trading-new.gif" alt="Automated Trading" />
              <p>Let it handle trading based on real-time AI insights, both technical and fundamental analysis, and automated strategies.</p>
            </li>
          </ul>
          <div className="split"></div>
        </div>
      </section>

      {/* Forex Section */}
      <section id="forex">
        <div className="wrapper">
          <img className="mob" src="https://grownit.io/imgs/forex1.gif" alt="Forex" />
          <h2>What is Forex?</h2>
          <p>Forex (short for the foreign exchange) refers to the global marketplace for buying and selling currencies. It is the largest and most liquid financial market in the world, with a daily trading volume exceeding $7 trillion as of 2024.</p>
          <br />
          <h3>Key Points:</h3>
          <ul>
            <li><strong><i className="fa fa-angle-down"></i> Purpose:</strong><br />To exchange one currency for another, mainly for trade, tourism, investment, or speculation.</li>
            <li><strong><i className="fa fa-angle-down"></i> How it works:</strong><br />Currencies are traded in pairs (e.g., EUR/USD, GBP/JPY). When you buy one currency, you simultaneously sell another.</li>
            <li><strong><i className="fa fa-angle-down"></i> Participants:</strong><br />Includes central banks, financial institutions, corporations, traders, and individual investors.</li>
          </ul>
          <br />
          <div className="newtab">
            <a href="#">LET'S START TRADING</a>
          </div>
          <div className="split"></div>
        </div>
      </section>

      {/* Market Trend Section */}
      <section id="market">
        <div className="wrapper">
          <h2>Market Trend</h2>
          <h4>"Stay ahead of the markets. Get the latest market news, trading analysis, and feature updates."</h4>
          <div className="grid">
            <figure className="effect-bubba">
              <img src="https://grownit.io/imgs/risk.jpg" alt="Risk" />
              <figcaption>
                <h3><span>3 Risk Management Tips You Need to Know</span></h3>
                <p>10 May 2025</p>
                <a href="#">View more</a>
              </figcaption>
            </figure>
            <figure className="effect-bubba">
              <img src="https://grownit.io/imgs/ai-trendz.jpg" alt="trendz" />
              <figcaption>
                <h3><span>The Fear & Greed Index: Today's Sentiment, Tomorrow's Trends?</span></h3>
                <p>02 June 2025</p>
                <a href="#">View more</a>
              </figcaption>
            </figure>
            <figure className="effect-bubba">
              <img src="https://grownit.io/imgs/nfc.jpg" alt="nfp" />
              <figcaption>
                <h3><span>Week 13 Data: Oil and Gold Before the NFP</span></h3>
                <p>5 June 2025</p>
                <a href="#">View more</a>
              </figcaption>
            </figure>
            <div className="split"></div>
          </div>
        </div>
      </section>

      {/* Affiliate Section */}
      {/* <section id="affiliate">
        <div className="wrapper">
          <h2>Affiliate Program</h2>
          <p>LogicraNetwork affiliates are an easy way to turn your traffic into extra income. Our lucrative program gives you the opportunity to refer your customers to Axi in exchange for commission. You can earn up to $1,200 CPA per qualified client, plus a 10% commission on sub-affiliate earnings if you become a Master Affiliate.</p>
          <br />
          <h3>Why Become a LogicraNetwork Affiliate?</h3>
          <ul>
            <li>
              <img src="https://grownit.io/imgs/max-earning.jpg" alt="Max Earnings" />
              <div>
                <h4>1. Tiered payment structure</h4>
                <p>Maximize your earnings as you increase traffic. The more clients you refer, the more commission you can earn per client.</p>
              </div>
            </li>
            <li>
              <img src="https://grownit.io/imgs/detailed-statics.jpg" alt="Detailed Statistics" />
              <div>
                <h4>2. Detailed statistics</h4>
                <p>Track your referred clients and monitor the performance of your campaigns.</p>
              </div>
            </li>
            <li>
              <img src="https://grownit.io/imgs/trading-marketing-tools-pic.jpg" alt="Marketing Tools" />
              <div>
                <h4>3. Marketing tools</h4>
                <p>Get banners and landing pages that are highly customized to your region, helping you bring in more clients.</p>
              </div>
            </li>
            <div className="split"></div>
            <li>
              <img src="https://grownit.io/imgs/monthly-payout.jpg" alt="Daily payments" />
              <div>
                <h4>4. Daily payments</h4>
                <p>Easily withdraw your commission with our hassle-free payment options.</p>
              </div>
            </li>
            <li>
              <img src="https://grownit.io/imgs/trusted-brand.jpg" alt="Trusted Brand" />
              <div>
                <h4>5. Trusted brand</h4>
                <p>Leverage the reputation of a trusted and multi-award-winning broker when you refer new clients.</p>
              </div>
            </li>
            <li>
              <img src="https://grownit.io/imgs/dedicated-account-manager.jpg" alt="Dedicated Manager" />
              <div>
                <h4>6. Dedicated account manager</h4>
                <p>Get support at every stage of your Affiliate journey, from an account manager that speaks your language.</p>
              </div>
            </li>
          </ul>
          <div className="split"></div>
          <br />
          <div className="newtab tcenter">
            <a href="#">Become An Affiliate Partner</a>
          </div>
        </div>
      </section> */}

      {/* Why Us Section */}
      <section id="whyus">
        <div className="wrapper">
          <h2>Why Choose Us?</h2>
          <h3>Many clients all over the world choose to trade with LogicraNetwork, and here are just a few reasons why:</h3>
          
       <div className="whyus-features-row">
      <div className="feature-box">
        <img src="https://grownit.io/imgs/secure-broker.jpg" alt="Secure Broker" />
        <h4>Secure Broker </h4>
      </div>
      <div className="feature-box">
        <img src="https://grownit.io/imgs/training-coach.jpg" alt="Training Coach" />
        <h4>Training with a Coach</h4>
      </div>
      <div className="feature-box">
        <img src="https://grownit.io/imgs/tradingtool.jpg" alt="Trading Tools" />
        <h4>Exclusive<br />Trading Tools</h4>
      </div>
      <div className="feature-box">
        <img src="https://grownit.io/imgs/deposite-b.jpg" alt="Deposit Bonuses" />
        <h4>Generous<br />Deposit Bonuses</h4>
      </div>
    </div>
          
          <div className="whyus-grid">
            <div className="whyus-item">
              <h5><i className="fa fa-angle-right"></i> Service excellence</h5>
              <p>While we continue to update our trading platform and features, our prime concern is providing our clients with nothing but the best service. We offer our clients personal training, attentive account managers and always put our clients first.</p>
            </div>
            
            <div className="whyus-item">
              <h5><i className="fa fa-angle-right"></i> Prudent risk management</h5>
              <p>Our professional teams ensure that neither our clients nor our business are left overly exposed to monetary disruption. We are well-prepared to face market turbulence without any interference to our trading services.</p>
            </div>
            
            <div className="whyus-item">
              <h5><i className="fa fa-angle-right"></i> Negative balance protection</h5>
              <p>This legally binding policy guarantees that our clients' accounts can never go into minus and they can never lose more than their investment even in times of extreme volatility.</p>
            </div>
            
            <div className="whyus-item">
              <h5><i className="fa fa-angle-right"></i> Real time margin protection</h5>
              <p>By using advanced technology and automatic precautions, customers at LogicraNetwork have full use of their accounts' margin, while limits are strictly monitored to prevent a negative balance.</p>
            </div>
            
            <div className="whyus-item">
              <h5><i className="fa fa-angle-right"></i> Trade with confidence</h5>
              <p>LogicraNetwork takes many steps to ensure its clients' security while allowing them to access market opportunities.</p>
            </div>
            
            <div className="whyus-item">
              <h5><i className="fa fa-angle-right"></i> Encryption services</h5>
              <p>Sensitive information is passed through encryption services such as firewalls and Secure Socket Layering (SSL).</p>
            </div>
            
            <div className="whyus-item">
              <h5><i className="fa fa-angle-right"></i> Segregated bank accounts</h5>
              <p>All client funds are stored with leading banks for enhanced protection and are completely separated from company capital.</p>
            </div>
            
            <div className="whyus-item">
              <h5><i className="fa fa-angle-right"></i> Advanced tools</h5>
              <p>We provide automated features and price transparency, use real-time account management and reporting as well as margin analysis, P&L, deal confirmation and market analysis.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq">
        <div className="wrapper">
          <h2>FAQs</h2>
          <h3>Frequently Asked Questions</h3>
          <div className="faq-list">
            <div className="faq-item">
              <div className="faq-question" onClick={() => toggleAccordion(0)}>
                <span>What is LogicraNetwork?</span>
                <span className="faq-toggle">{activeAccordion === 0 ? "−" : "+"}</span>
              </div>
              {activeAccordion === 0 && (
                <div className="faq-answer">
                  It is a premier trading platform that presents a variety of AI-Pooled Financial solutions programs opportunities in Forex and crypto trading. We amalgamate the expertise of experienced traders with AI-powered robot trading to help you attain your financial objectives.
                </div>
              )}
            </div>
            
            <div className="faq-item">
              <div className="faq-question" onClick={() => toggleAccordion(1)}>
                <span>What AI trading pool packages are available?</span>
                <span className="faq-toggle">{activeAccordion === 1 ? "−" : "+"}</span>
              </div>
              {activeAccordion === 1 && (
                <div className="faq-answer">
                  We offer a variety of strategy pool packages tailored to suit different risk profiles and trading experience. Whether you're a novice or an experienced trader, we have packages designed to meet your requirements.
                </div>
              )}
            </div>
            
            <div className="faq-item">
              <div className="faq-question" onClick={() => toggleAccordion(2)}>
                <span>Can I engage in collaborative learning and trading?</span>
                <span className="faq-toggle">{activeAccordion === 2 ? "−" : "+"}</span>
              </div>
              {activeAccordion === 2 && (
                <div className="faq-answer">
                  Yes, LogicraNetwork offers the opportunity to participate in collaborative learning and trading through our Pooled solutions program. This enables you to combine your resources with others for larger trading positions and increased profit potential. For this you must be sure, that markets are subject to RISK of losing funds.
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Address Bar */}
      <div className="add">
        <i className="fa fa-map-marker"></i> <strong>Address:</strong> <span>Dubai, United Arab Emirates</span> &nbsp; 
        <i className="fa fa-envelope"></i> <a href="mailto:info@logicranetwork.com">info@logicranetwork.com</a>
      </div>

      {/* Footer */}
      <footer>
        <div className="wrapper">
          <div className="botlogo">
            <img src={logo} alt="LogicraNetwork" />
          </div>
          <div className="socialicons">
            <a href="https://www.facebook.com/LogicraNetwork" target="_blank" rel="noreferrer"><i className="fa fa-facebook"></i></a>
            <a href="https://youtube.com/@logicranetwork⁠" target="_blank" rel="noreferrer"><i className="fa fa-youtube"></i></a>
            <a href="https://t.me/logicranetwork" target="_blank" rel="noreferrer"><i className="fa fa-telegram"></i></a>
            <a href="https://www.instagram.com/logicranetwork?igsh=MXFiZ2N1bDhnZmNwYw==" target="_blank" rel="noreferrer"><i className="fa fa-instagram"></i></a>
            <a href="https://x.com/LogicraNetwork" target="_blank" rel="noreferrer"><i className="fa fa-twitter"></i></a>
          </div>
          <div className="split"></div>
          <div className="copyright">
            <span>© 2026 LogicraNetwork, All Rights Reserved</span>
            <a href="#">Risk Disclosure</a>
            <a href="#">Privacy Policy</a>
          </div>
          <div className="split"></div>
          <div className="disclaimer">
            <p><strong>Disclaimer – Risk Disclosure</strong></p>
            <p>Trading foreign exchange (forex) on margin carries a high level of risk and may not be suitable for all investors. Leverage can work against you as well as for you. Before deciding to trade, you should carefully consider your investment objectives, level of experience, and risk tolerance. There is a possibility that you could sustain a loss of some or all of your initial investment. Do not trade with capital you cannot afford to lose.</p>
            <p>All content provided by LogicraNetwork, including any performance data, trade examples, or educational material, is intended for informational and educational purposes only. It does not constitute financial advice or a recommendation to buy or sell any financial instruments. You should seek advice from an independent financial advisor if you have any doubts or questions.</p>
            <p>CFTC RULE 4.41 – HYPOTHETICAL OR SIMULATED PERFORMANCE RESULTS HAVE CERTAIN LIMITATIONS. Unlike an actual performance record, simulated results do not represent actual trading. Also, since the trades have not been executed, the results may have under- or over-compensated for the impact, if any, of certain market factors, such as lack of liquidity. Simulated trading programs in general are also subject to the fact that they are designed with the benefit of hindsight. No representation is being made that any account will or is likely to achieve profits or losses similar to those shown.</p>
            <p>By using LogicraNetwork software and services, you acknowledge that you fully understand the risks involved and agree that LogicraNetwork and its affiliated parties bear no responsibility for any direct or indirect loss or damage resulting from the use of this product. Past performance is not necessarily indicative of future results.</p>
          </div>
        </div>
      </footer>

      {/* Back to Top Button */}
      <div className="top">
        <a href="#top"><i className="fa fa-angle-up"></i></a>
      </div>
    </div>
  );
};

export default Home;